/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";

// Author (optional agar aapko avatar dikhana ho)
function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="rounded" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography textTransform="none" variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

const useBoardData = (handleDeleteClick, handleEditClick, refresh) => {
  const [rows, setRows] = useState([]);
  const [count, setcount] = useState(0);

  const columns = [
    { name: "sno", align: "center" },
    { name: "Board", align: "center" },
    { name: "additionalFee", align: "center" },
    { name: "action", align: "center" },
  ];

  useEffect(() => {
    axios
      .get(`${baseURL}/boards`)
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data;
          const activeBoards = data.filter((board) => !board.isDeleted);
          setcount(activeBoards.length);
          if (activeBoards.length === 0) {
            setRows([]);
          } else {
            const formattedRows = activeBoards.map((item, index) => ({
              sno: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {index + 1}
                </ArgonTypography>
              ),
              Board: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {item.name}
                </ArgonTypography>
              ),
              additionalFee: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {Number(item.additionalFeePercentage || 0)}%
                </ArgonTypography>
              ),
              action: (
                <ArgonBox display="flex" alignItems="center" gap={0}>
                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "12px", p: 0 }}
                    onClick={() => handleEditClick(item._id, item.name, item.additionalFeePercentage)}
                  >
                    <EditIcon color="warning" />
                  </ArgonButton>

                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "32px", p: 0 }}
                    onClick={() => handleDeleteClick(item._id)}
                  >
                    {/* <DeleteIcon color="error" /> */}
                  </ArgonButton>
                </ArgonBox>
              ),
            }));
            setRows(formattedRows);
          }
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching boards:", err);
        const backendError = err.response?.data?.error;
        if (backendError) {
          toast.error(backendError);
        }
      });
  }, [refresh]);

  return { columns, rows, count };
};

export default useBoardData;

